// usar la referencia para limpiar el campo cuando no se selecciona nada
import React from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import {
  HrBorderRadiusInputs,
  HrFont,
  HrGray,
  HrGrey,
  HrlighterGrey,
  HrlightestGrey,
  HrPastelGreen,
  HrPrimary,
  HrRed,
  HrTransitionDuration,
  HrTransitionTimingCunction
} from '@components/styles/hr-styles';
import { get } from 'lodash';
import PropTypes from 'prop-types';

export const MySelect = styled(Select)`
  & .custom-hr-select__input{
    color: ${(props) => (props.darkMode ? 'white' : '')}
  }

  & .custom-hr-select__single-value {
    color: ${(props) => (props.darkMode ? 'white' : '')};
  }

  &.custom-hr-select-container {
    font-family: 'Open Sans', sans-serif;
    width: 100%;
    border-radius: ${HrBorderRadiusInputs};
    height: 40px;
    font-size: 14px;

    &.error .custom-hr-select__control {
      border-color: ${HrRed};
      & .custom-hr-select__value-container {
        & .custom-hr-select__placeholder {
          color: ${HrRed};
        }
      }
    }

    & .custom-hr-select__control {
      background-color: ${(props) => (props.darkMode ? 'transparent' : '')};
      border: 1px solid ${HrlighterGrey};
      border-radius: ${HrBorderRadiusInputs};
      height: 40px;

      & .custom-hr-select__value-container {
        padding: 2px 14px;
        & .custom-hr-select__placeholder {
          color: ${HrGrey};
          white-space: nowrap;
          font-size: ${(props) => `${14 + (props.fontSizeSetting || 0)}px`};
          font-family: ${HrFont};
        }
      }

      & .custom-hr-select__indicators {
        & .custom-hr-select__indicator-separator {
          display: none;
        }
        & .custom-hr-select__indicator {
          color: ${HrPrimary};
          transition: transform ${HrTransitionDuration} ${HrTransitionTimingCunction};
        }
      }
    }

    & .custom-hr-select__control--is-disabled {
      background-color:  ${(props) => (props.darkMode ? '#3c3c54' : HrlightestGrey)};
      color: ${HrGrey};
      border-color: ${HrlighterGrey};
      & .custom-hr-select__indicators {
        & .custom-hr-select__indicator {
          color: ${HrGrey};
        }
      }
    }

    & .custom-hr-select__control--is-focused {
      border: 1px solid ${HrGray};
      border-radius: ${HrBorderRadiusInputs};
      box-shadow: none;
    }

    & .custom-hr-select__control--menu-is-open {
      & .custom-hr-select__indicators {
        & .custom-hr-select__indicator-separator {
          display: none;
        }
        & .custom-hr-select__indicator {
          transform: rotateZ(180deg);
          transition: transform ${HrTransitionDuration} ${HrTransitionTimingCunction};
        }
      }
    }

    & .custom-hr-select__menu {
      background-color: ${(props) => (props.darkMode ? '#1A1D2B' : '')};
      color: ${(props) => (props.darkMode ? 'white' : '')};
      border-radius: ${HrBorderRadiusInputs};
      box-shadow: none;
      border: 1px solid ${HrGray};
      overflow: hidden;
      margin: 0;
      margin-top: 4px;
      z-index: 3;
      & .custom-hr-select__menu-list {
        font-size: 14px;
        & .custom-hr-select__option {
        }
        & .custom-hr-select__option--is-focused {
          background-color: ${HrPastelGreen};
          font-size: 14px;
          color: ${(props) => (props.darkMode ? 'black' : '')};
        }
        & .custom-hr-select__option--is-selected {
          background-color: ${HrlighterGrey};
          color: hsl(0, 0%, 20%); // TODO: sace el color de la libreria
        }
      }
    }
  }
`;

export const HrSelect = ({
  data,
  darkMode,
  selected,
  placeholder,
  inputRef,
  inputId,
  onChange,
  onClick,
  isSearchable,
  isLoading,
  disabled,
  formState,
  filterOption,
  fontSizeSetting
}) => {
  return (
    <MySelect
      selected={selected}
      inputRef={inputRef}
      inputId={inputId}
      darkMode={darkMode}
      placeholder={placeholder}
      options={data}
      isDisabled={disabled}
      maxMenuHeight={180}
      fontSizeSetting={fontSizeSetting}
      isSearchable={isSearchable}
      value={data.find((c) => c.value == selected) || null}
      onChange={(e) => {
        onClick(e);
        onChange(e.value);
      }}
      className={`custom-hr-select-container ${get(formState?.errors, inputId) ? 'error' : ''}`}
      classNamePrefix='custom-hr-select'
      openMenuOnFocus
      isMulti={false}
      isClearable={false}
      isLoading={isLoading}
      filterOption={filterOption}
      noOptionsMessage={() => 'Sin opciones'}
    />
  );
};

HrSelect.propTypes = {
  id: PropTypes.string,
  data: PropTypes.array,
  onChangee: PropTypes.func,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  isSearchable: PropTypes.bool,
  formState: PropTypes.object,
  filterOption: PropTypes.func,
  placeholder: PropTypes.string,
  maxMenuHeight: PropTypes.number
};

HrSelect.defaultProps = {
  id: '',
  data: [],
  onChangee: () => {},
  onClick: () => {},
  isLoading: false,
  isSearchable: true,
  placeholder: 'Seleccione una opción'
};

// El atributo value tiene un == a proposito, no lo modifiquen o pagan empanadas
